// classes related to message threads


import { DateTime } from 'luxon';
//import { buildNestedCategoriesFromFlat } from './categories';


class MessageThreadReadStatus {
    constructor({
        has_unread,
        last_read_on,
    }) {
        this.has_unread = has_unread;  // boolean, leave it as is
        this.last_read_on = last_read_on ? DateTime.fromISO(last_read_on) : null;
    }
}


export {
    MessageThreadReadStatus,
}